export const environment = {
  production: true,
  graphqlUri: 'https://api-v2.webbuy.dev/prod/graphql',
  clientAppUrl: 'https://client-v2.webbuy.dev/prod/',
  stage: 'prod',
  aws: {
    region: 'us-west-2',
    identityPoolId: 'us-west-2:79459737-d3ed-444e-a62a-730fa2b3a0cb',
    userPoolId: 'us-west-2_NaqpHjTO7',
    userPoolWebClientId: '3ljn9rujj60u804kh8lm64vmnv',
    accessKeyId: 'AKIASOAFB6X7MGMEWF5K',
    secretAccessKey: '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',
    bucketName: 'webbuy-v2-admin-account-assets',
    userPoolDomain: 'webbuy-prod-admin.auth.us-west-2.amazoncognito.com',
    cdnUri: 'https://cdn-v2.webbuy.dev',
    oauthRedirectSignIn: 'https://admin-v2.webbuy.dev/prod/',
    oauthRedirectSignOut: 'https://admin-v2.webbuy.dev/prod/',
    inviteNewUsersEndpoint: 'https://2wiwnpvu26.execute-api.us-west-2.amazonaws.com/prod/inviteNewUsers',
  },
};
